import { render, staticRenderFns } from "./ImportContactsDialog.vue?vue&type=template&id=187b3b9a"
import script from "./ImportContactsDialog.vue?vue&type=script&lang=js"
export * from "./ImportContactsDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportContactsDialog.vue?vue&type=style&index=0&id=187b3b9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports